import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import {
  LaboratorioLezioneTutoraggioDTO,
  ListMieiLaboratoriDTO,
} from '../../../model/newModel';
import { SharedService } from '../../../shared/shared.service';
import { DashboardTutorService } from './dashboard-tutor.service';

@Component({
  selector: 'app-dashboard-tutor',
  templateUrl: './dashboard-tutor.component.html',
  styleUrls: ['./dashboard-tutor.component.css'],
})
export class DashboardTutorComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  mieiLaboratoriOggi: LaboratorioLezioneTutoraggioDTO[];
  mieiLaboratoriPrecedenti: LaboratorioLezioneTutoraggioDTO[];
  now: Date;
  agendeDaVerificare: number;
  appelliDaEffettuare: number;

  ngOnInit(): void {
    this.now = new Date();
    super.ngOnInit();
    this.loadMieiLaboratori();
    this.loadAgendeDaVerificare();
  }

  goToAgendeDaVerificare() {
    this.router.navigate(['a-agenda/verificare']);
  }

  goToCalendari() {
    this.router.navigate(['a-laboratorio-lezione-tutoraggio/calendario']);
  }

  goToAppelliDaFare() {
    this.router.navigate(['a-laboratorio-lezione-tutoraggio/appelli']);
  }

  loadAgendeDaVerificare() {
    this.spinner.show();
    this.sharedService.getTotaleAgendeDaVerificare().subscribe(
      (result: number) => {
        this.agendeDaVerificare = result;
        this.spinner.hide();
      },
      (error) => {
        console.log('Errore getTotaleAgendeDaVerificare');
        this.spinner.hide();
      }
    );
  }

  loadMieiLaboratori() {
    this.spinner.show();
    this.dashboardTutorService.getMieiLaboratori(this.tutor.id).subscribe(
      (result: ListMieiLaboratoriDTO) => {
        this.mieiLaboratoriOggi = result.laboratoriLezioneTutoraggio;
        this.mieiLaboratoriPrecedenti =
          result.laboratoriLezioneTutoraggioPrecedenti;
        this.appelliDaEffettuare = this.mieiLaboratoriPrecedenti.length;
        this.spinner.hide();
      },
      (error) => {
        console.log('Errore getMieiLaboratori');
        this.spinner.hide();
      }
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  constructor(
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    public router: Router,
    private dashboardTutorService: DashboardTutorService
  ) {
    super();
  }

  goToLaboratorioDetail(idLaboratorioLezioneTutoraggio: number) {
    this.router.navigate(['/a-laboratorio-lezione-tutoraggio/dettaglio'], {
      queryParams: {
        idLaboratorioLezioneTutoraggio: idLaboratorioLezioneTutoraggio,
      },
    });
  }
}
